export default {
  RESET_CONVERSATION: '@CLIENTELING_RESET_CONVERSATION',
  STORE_PRODUCT_LINK: '@CLIENTELING_STORE_PRODUCT_LINK',

  ADD_ATTACHMENTS: '@CLIENTELING_ADD_ATTACHMENTS',
  REMOVE_ATTACHMENTS: '@CLIENTELING_REMOVE_ATTACHMENTS',

  GET_ATTACHMENTS_DATASOURCE_LOADING: '@CLIENTELING_GET_ATTACHMENTS_DATASOURCE_LOADING',
  GET_ATTACHMENTS_DATASOURCE_SUCCESS: '@CLIENTELING_GET_ATTACHMENTS_DATASOURCE_SUCCESS',
  GET_ATTACHMENTS_DATASOURCE_ERROR: '@CLIENTELING_GET_ATTACHMENTS_DATASOURCE_ERROR',

  SEND_ATTACHMENTS_LOADING: '@CLIENTELING_SEND_ATTACHMENTS_LOADING',
  SEND_ATTACHMENTS_SUCCESS: '@CLIENTELING_SEND_ATTACHMENTS_SUCCESS',
  SEND_ATTACHMENTS_ERROR: '@CLIENTELING_SEND_ATTACHMENTS_ERROR',

  ADD_NEW_REPCIPIENT: '@CLIENTELING_ADD_NEW_REPCIPIENT',
  ADD_NEW_RECIPIENTS: '@CLIENTELING_ADD_NEW_RECIPIENTS',

  DELETE_REPCIPIENT: '@CLIENTELING_DELETE_REPCIPIENT',

  CLIENTS_LIST_SUCCESS: '@CLIENTELING_CLIENTS_LIST_SUCCESS',
  CLIENTS_LIST_LOADING: '@CLIENTELING_CLIENTS_LIST_LOADING',
  CLIENTS_LIST_ERROR: '@CLIENTELING_CLIENTS_LIST_ERROR',

  MESSAGES_LIST_SUCCESS: '@CLIENTELING_MESSAGES_LIST_SUCCESS',
  MESSAGES_LIST_LOADING: '@CLIENTELING_MESSAGES_LIST_LOADING',
  MESSAGES_LIST_ERROR: '@CLIENTELING_MESSAGES_LIST_ERROR',

  MESSAGES_LIST_V2_SUCCESS: '@CLIENTELING_MESSAGES_LIST_V2_SUCCESS',
  MESSAGES_LIST_V2_LOADING: '@CLIENTELING_MESSAGES_LIST_V2_LOADING',
  MESSAGES_LIST_V2_ERROR: '@CLIENTELING_MESSAGES_LIST_V2_ERROR',
  CLEAR_MESSAGES_LIST: '@CLIENTELING_CLEAR_MESSAGES_LIST',

  GET_CONVERSATIONS_V2_LOADING: '@CLIENTELING_GET_CONVERSATIONS_V2_LOADING',
  GET_CONVERSATIONS_V2_SUCCESS: '@CLIENTELING_GET_CONVERSATIONS_V2_SUCCESS',
  GET_CONVERSATIONS_V2_ERROR: '@CLIENTELING_GET_CONVERSATIONS_V2_ERROR',
  CLEAR_CONVERSATIONS: '@CLIENTELING_CLEAR_CONVERSATIONS',

  DO_VOICE_CALL: '@CLIENTELING_DO_VOICE_CALL',
  DO_VOICE_CALL_SUCCESS: '@CLIENTELING_DO_VOICE_CALL_SUCCESS',
  DO_VOICE_CALL_ERROR: '@CLIENTELING_DO_VOICE_CALL_ERROR',

  UPDATE_CONVERSATION: '@CLIENTELING_UPDATE_CONVERSATION',

  ADD_MESSAGE: '@CLIENTELING_ADD_MESSAGE',
  UPDATE_MESSAGE: '@CLIENTELING_UPDATE_MESSAGE',
  MARK_MESSAGE_READ: '@CLIENTELING_MARK_MESSAGE_READ',

  SHARED_PRODUCT_DETAILS_LOADING: '@CLIENTELING_SHARED_PRODUCT_DETAILS_LOADING',
  SHARED_PRODUCT_DETAILS_SUCCESS: '@CLIENTELING_SHARED_PRODUCT_DETAILS_SUCCESS',
  SHARED_PRODUCT_DETAILS_ERROR: '@CLIENTELING_SHARED_PRODUCT_DETAILS_ERROR',

  SET_CLIENT_FOR_CLIENT_INBOX: '@CLIENTELING_SET_CLIENT_FOR_CLIENT_INBOX',
  CLEAR_CLIENT_FOR_CLIENT_INBOX: '@CLIENTELING_CLEAR_CLIENT_FOR_CLIENT_INBOX',

  CLIENT_INBOX_LOADING: '@CLIENTELING_CLIENT_INBOX_LOADING',
  CLIENT_INBOX_SUCCESS: '@CLIENTELING_CLIENT_INBOX_SUCCESS',
  CLIENT_INBOX_ERROR: '@CLIENTELING_CLIENT_INBOX_ERROR',
  CLIENT_INBOX_RESET: '@CLIENTELING_CLIENT_INBOX_RESET',

  MARKETING_ASSETS_LOADING: '@CLIENTELING_MARKETING_ASSETS_LOADING',
  MARKETING_ASSETS_ERROR: '@CLIENTELING_MARKETING_ASSETS_ERROR',

  MARKETING_SCRIPTS_LOADING: '@CLIENTELING_MARKETING_SCRIPTS_LOADING',
  MARKETING_SCRIPTS_ERROR: '@CLIENTELING_MARKETING_SCRIPTS_ERROR',
  GET_MARKETING_SCRIPTS_SUCCESS: '@CLIENTELING_GET_MARKETING_SCRIPTS_SUCCESS',

  GET_MARKETING_ASSETS_SUCCESS: '@CLIENTELING_GET_MARKETING_ASSETS_SUCCESS',
  SEARCH_MARKETING_ASSETS_SUCCESS: '@CLIENTELING_SEARCH_MARKETING_ASSETS_SUCCESS',
  NEW_SEARCH_MARKETING_ASSETS_SUCCESS: '@CLIENTELING_NEW_SEARCH_MARKETING_ASSETS_SUCCESS',

  ADD_MARKETING_ASSETS: '@CLIENTELING_ADD_MARKETING_ASSETS',

  RESET_MARKETING_ASSETS: '@CLIENTELING_RESET_MARKETING_ASSETS',
  RESET_SEARCH_MARKETING_ASSETS: '@CLIENTELING_RESET_SEARCH_MARKETING_ASSETS',

  EMAIL_TEMPLATE_LOADING: '@CLIENTELING_EMAIL_TEMPLATE_LOADING',
  EMAIL_TEMPLATE_SUCCESS: '@CLIENTELING_EMAIL_TEMPLATE_SUCCESS',
  EMAIL_TEMPLATE_ERROR: '@CLIENTELING_EMAIL_TEMPLATE_ERROR',
  CLEAR_EMAIL_TEMPLATE: '@CLIENTELING_CLEAR_EMAIL_TEMPLATE',

  GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_STARTED: '@GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_STARTED',
  GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_FAILED: '@GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_FAILED',
  GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS: '@GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS',

  SET_ASSOCIATE_EMAIL_SIGNATURE_STARTED: '@SET_ASSOCIATE_EMAIL_SIGNATURE_STARTED',
  SET_ASSOCIATE_EMAIL_SIGNATURE_FAILED: '@SET_ASSOCIATE_EMAIL_SIGNATURE_FAILED',
  SET_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS: '@SET_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS',

  SET_EMAIL_PREFERENCES: '@CLIENTELING_SET_EMAIL_PREFERENCES',

  SET_EMAIL_LOOK_DATA: '@CLIENTELING_SET_EMAIL_LOOK_DATA',
};
